var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "border border-solid d-theme-border-grey-light rounded relative overflow-hidden",
      attrs: { id: "todo-app" },
    },
    [
      _c(
        "vs-sidebar",
        {
          staticClass: "items-no-padding",
          attrs: {
            parent: "#todo-app",
            "click-not-close": _vm.clickNotClose,
            "hidden-background": _vm.clickNotClose,
          },
          model: {
            value: _vm.isSidebarActive,
            callback: function ($$v) {
              _vm.isSidebarActive = $$v
            },
            expression: "isSidebarActive",
          },
        },
        [
          _c("todo-add-new"),
          _c(
            "VuePerfectScrollbar",
            {
              staticClass: "todo-scroll-area",
              attrs: { settings: _vm.settings },
            },
            [
              _c("todo-filters", {
                on: { closeSidebar: _vm.toggleTodoSidebar },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass:
            "app-fixed-height border border-r-0 border-b-0 border-t-0 border-solid d-theme-border-grey-light app-fixed-height",
          class: { "sidebar-spacer": _vm.clickNotClose },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "flex items-center app-search-container border border-l-0 border-r-0 border-t-0 border-solid d-theme-border-grey-light",
            },
            [
              _c("feather-icon", {
                staticClass:
                  "md:inline-flex lg:hidden ml-4 mr-4 cursor-pointer",
                attrs: { icon: "MenuIcon" },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.toggleTodoSidebar(true)
                  },
                },
              }),
              _c("vs-input", {
                staticClass:
                  "vs-input-no-border vs-input-no-shdow-focus no-icon-border w-full",
                attrs: {
                  size: "large",
                  "icon-pack": "feather",
                  icon: "icon-search",
                  placeholder: "Search...",
                },
                model: {
                  value: _vm.searchQuery,
                  callback: function ($$v) {
                    _vm.searchQuery = $$v
                  },
                  expression: "searchQuery",
                },
              }),
            ],
            1
          ),
          _c(
            "VuePerfectScrollbar",
            {
              ref: "todoListPS",
              staticClass: "todo-content-scroll-area",
              attrs: { settings: _vm.settings },
            },
            [
              _c(
                "transition-group",
                {
                  staticClass: "todo-list",
                  attrs: { name: "list-enter-up", tag: "ul", appear: "" },
                },
                _vm._l(_vm.todoList, function (todoItem, index) {
                  return _c(
                    "li",
                    {
                      key: String(_vm.todoFilter) + String(todoItem.id),
                      staticClass: "cursor-pointer todo_todo-item",
                      style: [{ transitionDelay: index * 0.1 + "s" }],
                    },
                    [
                      _c("todo-item", {
                        attrs: { todoItemId: todoItem.id },
                        on: {
                          showDisplayPrompt: function ($event) {
                            return _vm.showDisplayPrompt($event)
                          },
                        },
                      }),
                    ],
                    1
                  )
                }),
                0
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.displayPrompt
        ? _c("todo-edit", {
            attrs: {
              displayPrompt: _vm.displayPrompt,
              todoItemId: _vm.todoIdToEdit,
            },
            on: { hideDisplayPrompt: _vm.hidePrompt },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }